import { ReactElement, useMemo } from 'react'

import classNames from 'classnames'

import { Icon } from 'components/core'

import { UserBadgeProps } from './types'
import * as styles from './UserBadge.module.scss'

const AVATAR_COLOR_COUNT = 10

function getColorIndexForEmail(email: string): number {
    let hash = 0
    for (let i = 0; i < email.length; i++) {
        hash = (hash << 5) - hash + email.charCodeAt(i)
        hash |= 0
    }
    return Math.abs(hash) % AVATAR_COLOR_COUNT
}

export const UserBadge = ({
    email,
    variant = 'badge',
}: UserBadgeProps): ReactElement => {
    const hasEmail = Boolean(email)
    const initial = hasEmail ? email.charAt(0).toUpperCase() : null
    const colorIndex = useMemo(
        () => (hasEmail ? getColorIndexForEmail(email) : null),
        [email, hasEmail]
    )

    const avatar = (
        <span
            className={classNames(
                styles['avatar'],
                colorIndex !== null && styles[`avatar--color-${colorIndex}`],
                {
                    [styles['avatar--fallback']]: !hasEmail,
                    [styles['avatar--large']]: variant === 'avatar',
                }
            )}
        >
            {initial ?? <Icon name="USER_OUTLINE" color="white" size={12} />}
        </span>
    )

    if (variant === 'avatar') {
        return avatar
    }

    return (
        <span className={styles['user-badge']}>
            {avatar}
            <span className={styles['email']}>{email}</span>
        </span>
    )
}
